export * from './offer-card-skeleton';
